import './style/index.less';
import SpanText from './SpanText';

export default SpanText;
